import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@domain-group/react-hooks'

import { Box, Button } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import useQuoteBuilder from '../../hooks/useQuoteBuilder'

import ApproveQuoteButton from '../ApproveQuoteButton'

const defaultState = {
  loading: false,
}

interface FooterActionsProps {
  campaignQuotePayload: ReturnType<typeof useQuoteBuilder>['campaignQuotePayload'],
  locked: boolean,
}

const FooterActions = (props: FooterActionsProps) => {
  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const {
    campaignQuotePayload,
    campaignQuotePayload: {
      callbacks: {
        deleteCampaignQuote: deleteFn,
      },
      isAwaitingReview,
      urls: {
        campaignQuotesIndexUrl,
        pdfDownloadUrl,
      },
    },
    locked,
  } = props

  const confirmDeletePayload = {
    callbacks: {
      afterAction: () => {
        window.location.href = campaignQuotesIndexUrl
      },
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This cannot be undone.',
      entityName: 'Quote',
    },
  }

  return (
    <Box
      alignItems={['flex-start', 'center']}
      borderTop="1px solid"
      borderColor="lineColor"
      flexDirection={['column', 'row']}
      padding="large"
    >
      <Box display={['none', 'flex']} width="auto">
        {!isAwaitingReview && (
          <Button
            buttonStyle="secondaryUtility"
            disabled={locked}
            icon={<FontAwesomeIcon icon={faTrashAlt} />}
            onClick={() => confirmDelete(confirmDeletePayload)}
            size="medium"
            // @ts-expect-error TS2322
            width="auto"
          >
            Delete
          </Button>
        )}

        <Box onClick={() => setState({ loading: true })}>
          <AuthenticatedDownload
            callbacks={{ afterAction: () => setState({ loading: false }) }}
            toastMessage="Quote generation in progress, please wait for download."
            key="download"
          >
            <Button
              // @ts-expect-error TS2322
              as="a"
              buttonStyle="secondaryUtility"
              href={pdfDownloadUrl}
              icon={<FontAwesomeIcon icon={faDownload} />}
              loading={loading}
              marginLeft={isAwaitingReview ? '' : 'medium'}
              size="medium"
              width={120}
            >
              Download
            </Button>
          </AuthenticatedDownload>
        </Box>
      </Box>

      <Box
        justifyContent="flex-end"
        marginLeft="auto"
        width={['100%', 'auto']}
      >
        <ApproveQuoteButton
          campaignQuotePayload={campaignQuotePayload}
        />
      </Box>
    </Box>
  )
}

export default FooterActions
